export default {
  // Errors
  emailNotConfirmed: 'Before proceeding, please confirm your Email',
  internalServerError: 'Internal server error',
  phoneNumberNotConfirmed: 'Before proceeding, please confirm your phone number',
  unauthorized: 'Authorization required',
  validationFailed: 'Validation failed',

  // Words
  active: 'Active',
  add: 'Add',
  address: 'Address',
  altName: 'Alt name',
  appLogo: '@:branding.appName Logo',
  approve: 'Approve',
  approved: 'Approved',
  areYouSure: 'Are you sure?',
  areYouSureToRemoveThisItem: 'Are you sure to remove this item?',
  attachments: 'Attachments',
  autoLocation: 'Automatic location',
  availability: 'Availability',
  bankAccounts: {
    accountOrShebaNo: 'Account / Sheba number',
    accountOwnerName: 'Account owener name',
    accountTitle: 'Account title',
    bankAccounts: 'Bank accounts',
    enterBankAccounts: 'Enter bank accounts',
    bankName: 'Bank name',
    branchCode: 'Branch code',
    branchName: 'Branch name',
    enterBankName: 'Enter bank\'s name',
    shebaNumber: 'Sheba number'
  },
  basicContractData: 'Basic contract data',
  basicFeatures: 'Basic features',
  cancel: 'Cancel',
  choose: 'Choose',
  code: 'Code',
  color: 'Color',
  companyName: 'Company name',
  contactNumber: 'Contact number',
  contacts: 'Contacts',
  contractExpireDate: 'Contract expire date',
  contractNum: 'Contract number',
  contractScan: 'Contract scan',
  coordinates: 'Coordinates',
  count: 'Count',
  create: 'Create',
  created: 'Created Date',
  createSomeCategoriesFirst: 'Please create at least one category first',
  customColor: 'Custom color',
  dateAndHour: 'Date and hour',
  deactive: 'Deactive',
  description: 'Description',
  details: 'Details',
  disapprove: 'Disapprove',
  disapproved: 'Disapproved',
  documents: {
    documentAttachments: '{document} attachments',
    documentName: '{document} name',
    documents: 'Documents',

    // System document types
    BirthCertificate: 'Birth certificate',
    BusinessLicense: 'Business license',
    LatestChangesAd: 'Latest changes ad',
    NationalCard: 'National card',
    OfficialNewspaper: 'Official newspaper',
    RegistrationAd: 'Registration ad',
    Statute: 'Statute',
    ValueAddedRegistrationCertificate: 'Value added registration certificate'
  },
  duplicateItem: 'Duplicate {title}',
  economicalCode: 'Economical code',
  edit: 'Edit',
  email: 'Email',
  expireDate: 'Expire date',
  fatherName: 'Father name',
  featured: 'Featured',
  fieldTypes: {
    personal: 'Personal',
    personalPhoneNumber: 'Personal phone number',
    personalTelephoneNumber: 'Personal telephone number',
    work: 'Work',
    workPhoneNumber: 'Work phone number',
    workTelephoneNumber: 'Work telephone number'
  },
  enterUserName: 'Enter user name',
  filling: 'Completing profile',
  headerImage: 'Header image',
  hour: 'Hour',
  icon: 'Icon',
  id: 'ID',
  identityData: 'Identity data',
  image: 'Image',
  individual: 'Individual',
  insertUnderContract: 'Insert under contract',
  invalidItem: 'Invalid {title}',
  lastDayOfExpireDate: 'Last day of {title} expire date',
  legal: 'Legal',
  logo: 'Logo',
  minutes: 'Minutes',
  name: 'Name',
  nationalId: 'National id',
  no: 'No',
  noMatchingRecords: 'There are no records matching your search',
  noRecords: 'There are no records to show',
  notApproved: 'Not approved',
  notes: 'Notes',
  oneReqiured: 'At least one of {fields} fields is required',
  oopsWeHaveAProblem: "Oops! we have a problem",
  oopsYouAreLost: "Oops! You're lost.",
  or: 'or',
  otherNames: 'Other names',
  pageDescription: 'Page description',
  pageDescriptionForSeo: 'Page description for Seo',
  pageTitle: 'Page title',
  passedExpireDate: 'One day passed from {title} expire date | {count} days passed from {title} expire date',
  password: 'Password',
  passwordConfirm: 'Password confirm',
  pending: 'Pending approve',
  person: 'Person',
  phoneNumber: 'Phone number',
  position: 'Position',
  precision: 'Precision',
  primaryCategory: 'Primary category',
  print: 'Print',
  publish: 'Publish',
  publishDate: 'Publish date',
  redirect: 'Permanent Redirect URL 301',
  regDate: 'Registeration date',
  regNum: 'Registeration number',
  relatedCategories: 'Related categories',
  remove: 'Remove',
  return: 'Return',
  save: 'Save',
  saveAndReviewRequest: 'Save and review request',
  seal: 'Seal image',
  search: 'Search',
  select: 'Select',
  selectedColor: 'Selected color',
  seoFeatures: 'Seo features',
  settings: 'Settings',
  showsInBrowserTab: 'Shows in browser tab',
  signatorCertification: 'Signator certification',
  signatories: 'Signatories',
  signatureImage: 'Signature image',
  slug: 'Slug',
  sortOrder: 'Sort Order',
  status: 'Status',
  statusUpdated: 'Status updated',
  submitedDate: 'Submited date',
  systemMessage: 'System message',
  tag: 'Tag',
  tags: 'Tags',
  text: 'Text',
  thePageYouAreLookingForIsTemporaryUnavailable: "The page you are looking for is temporarily unavailable.",
  thePageYouAreLookingForWasNotFound: 'The page you are looking for was not found.',
  tillExpireDate: 'One day till {title} expire date | {count} days till {title} expire date',
  title: 'Title',
  type: 'Type',
  to: 'to',
  url: 'Url',
  user: 'User',
  userData: 'User data',
  view: 'View',
  viewData: 'View data',
  website: 'Website',
  yes: 'Yes',
  youAreOffline: 'It seems you are offline from server.',
  youHave: 'You have'
}
